import { useNavigate } from "@tanstack/react-router"
import { useCallback } from "react"

import { DEMAND2_PERFORMANCE_TABLE_ID } from "~/constants"
import { useTableSearch } from "~/hooks/useTableSearch"
import type { CollectionKind } from "~/utils/collectionKind"

/** Must match the grid id the Performance tab registers on a collection (or group) route. */
export const performanceTableId = (scopeId: number) => `${DEMAND2_PERFORMANCE_TABLE_ID}-${scopeId}`

/** Opens a collection's Performance tab searched down to one variant. */
export const useOpenInPerformance = (collectionId: number, kind: CollectionKind) => {
  const navigate = useNavigate()
  const { setSearchText } = useTableSearch(performanceTableId(collectionId))
  return useCallback(
    (variantId: string) => {
      setSearchText(`variantId:"${variantId}"`)
      void navigate({
        to:
          kind === "noos"
            ? "/demand/noos/$collectionId/performance"
            : "/demand/fashion/$collectionId/performance",
        params: { collectionId: String(collectionId) },
        search: (prev: Record<string, unknown>) => ({ ...prev, strategy: undefined }),
      })
    },
    [setSearchText, navigate, collectionId, kind],
  )
}
